import { getLineHeight } from '../../lib/utils';

const lineHeightRatio = 1.3;
const lineHeight = getLineHeight(lineHeightRatio);

export const typography = {
  headings: {
    deca: {
      fontSize: '14px',
      lineHeight: `${lineHeight(16)}px`,
    },
    kilo: {
      fontSize: '17px',
      lineHeight: `${lineHeight(17)}px`,
    },
    mega: {
      fontSize: '18px',
      lineHeight: `${lineHeight(19)}px`,
    },
    giga: {
      fontSize: '21px',
      lineHeight: `${lineHeight(21)}px`,
    },
    tera: {
      fontSize: '24px',
      lineHeight: `${lineHeight(24)}px`,
    },
    peta: {
      fontSize: '28px',
      lineHeight: `${lineHeight(28)}px`,
    },
    exa: {
      fontSize: '40px',
      lineHeight: `${lineHeight(40)}px`,
    },
    zetta: {
      fontSize: '70px',
      lineHeight: `${lineHeight(70)}px`,
    },
    yotta: {
      fontSize: '105px',
      lineHeight: `${lineHeight(105)}px`,
      letterSpacing: '4px',
    },
  },
  subHeadings: {
    byte: {
      fontSize: '11px',
      lineHeight: `${lineHeight(11)}px`,
    },
    kilo: {
      fontSize: '12px',
      lineHeight: `${lineHeight(12)}px`,
    },
    mega: {
      fontSize: '14px',
      lineHeight: `${lineHeight(14)}px`,
      letterSpacing: '-0.22px',
    },
    tera: {
      fontSize: '32px',
      lineHeight: `${lineHeight(24)}px`,
      letterSpacing: '2px',
    },
    peta: {
      fontSize: '36px',
      lineHeight: `${lineHeight(36)}px`,
      letterSpacing: '2px',
    },
    exa: {
      fontSize: '40px',
      lineHeight: `${lineHeight(40)}px`,
      letterSpacing: '-2.17px',
    },
  },
  text: {
    atom: {
      fontSize: '9px',
      lineHeight: `${lineHeight(9)}px`,
    },
    bit: {
      fontSize: '10px',
      lineHeight: `${lineHeight(10)}px`,
    },
    byte: {
      fontSize: '11px',
      lineHeight: `${lineHeight(11)}px`,
    },
    kilo: {
      fontSize: '12px',
      lineHeight: `${lineHeight(12)}px`,
    },
    mega: {
      fontSize: '13px',
      lineHeight: `${lineHeight(13)}px`,
    },
    giga: {
      fontSize: '14px',
      lineHeight: `${lineHeight(14)}px`,
      letterSpacing: '-0.22px',
    },
    tera: {
      fontSize: '16px',
      lineHeight: `${lineHeight(16)}px`,
      letterSpacing: '-0.06px',
    },
    peta: {
      fontSize: '18px',
      lineHeight: `${lineHeight(18)}px`,
      letterSpacing: '-0.28px',
    },
    exa: {
      fontSize: '20px',
      lineHeight: `${lineHeight(20)}px`,
    },
    zetta: {
      fontSize: '22px',
      lineHeight: `${lineHeight(22)}px`,
    },
    yotta: {
      fontSize: '26px',
      lineHeight: `${lineHeight(26)} px`,
    },
  },
};
